import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from 'src/app/auth-config.module';

import { UserService } from '../services/lmsuser.service';

export function initializeAppAuth(
  oauthService: OAuthService,
  userService: UserService,
): () => Promise<boolean> {
  return async () => {
    try {
      oauthService.events.subscribe((event: OAuthEvent) => {
        if (event.type === 'session_error' || event.type === 'token_error') {
          console.error('OAuth session/token error detected during bootstrap:', event);
          oauthService.revokeTokenAndLogout(true);
          return;
        }

        if (event.type === 'token_expires') {
          oauthService.refreshToken().catch((error) => {
            console.error('OAuth token refresh failed on token_expires:', error);
            oauthService.revokeTokenAndLogout(true);
          });
        }
      });

      oauthService.configure(authConfig);
      oauthService.setStorage(localStorage);

      const isLoggedIn = await oauthService.loadDiscoveryDocumentAndLogin();
      if (!isLoggedIn) {
        return true;
      }

      await userService.loadLMSUserProfile(
        oauthService.getIdentityClaims() as Record<string, any> | null,
      );
      oauthService.setupAutomaticSilentRefresh();
      return true;
    } catch (error) {
      console.error('APP_INITIALIZER auth bootstrap failed:', error);
      return true;
    }
  };
}
